export default "/images/vendor/@material-design-icons/svg/filled/thumb_up.svg?cba6f0957c70c06b7071b6e9c3583e45";